import React, { Component, Fragment } from "react";
import SimpleSlider from "./Slider";
import Statistics from "./Statistics";

export default class Office extends Component {
  render() {
    return (
      <Fragment>
        <SimpleSlider />
        <Statistics />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/office/index.jsx